import { render, staticRenderFns } from "./UploadFileModal.vue?vue&type=template&id=7b824be4&scoped=true"
import script from "./UploadFileModal.vue?vue&type=script&lang=ts"
export * from "./UploadFileModal.vue?vue&type=script&lang=ts"
import style0 from "./UploadFileModal.vue?vue&type=style&index=0&id=7b824be4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b824be4",
  null
  
)

export default component.exports